import React from "react"
import { Text, TextProps } from "@chakra-ui/react"
import replaceEventNamePlaceholder from "utilities/replaceEventNamePlaceholder"

type Props = TextProps & {
  text: string
  eventName?: string
}

/** Renders event translation copy with {{EVENT_NAME}} substitution and preserved line breaks. */
const EventTranslationText = ({ text, eventName, ...rest }: Props) => (
  <Text whiteSpace="pre-wrap" {...rest}>
    {replaceEventNamePlaceholder(text, eventName)}
  </Text>
)

export default EventTranslationText
